import React, { useState } from 'react';
import './index.scss';
import { Dropdown } from 'antd';
import CompleteIssue from '../CompleteIssue';
import OnHoldIssue from '../OnHoldIssue';
import TransferIssue from '../TransferIssue';
import DiscardIssue from '../DiscardIssue';
import CreateIssue from '../CreateIssue';
import CreateRepairOrder from '../CreateRepairOrder';

const WordOrderCommand = (props: {
  vehicleName: string;
  LC_BUTTON_R2?: boolean; // 完结工单
  LC_BUTTON_L3?: boolean;
  isPageVisible: boolean;
}) => {
  const { vehicleName, LC_BUTTON_R2, LC_BUTTON_L3 } = props;
  const [dropdownBtnsShow, setDropdownBtnsShow] = useState(false);

  const dropdownContent = (
    <div className="vehicle-command-panel" onClick={(e) => e.stopPropagation()}>
      <div className="command-row">
        <TransferIssue
          vehicleName={vehicleName}
          closeDropdown={() => setDropdownBtnsShow(false)}
        />
        <CompleteIssue
          vehicleName={vehicleName}
          closeDropdown={() => setDropdownBtnsShow(false)}
        />
      </div>
      <div className="command-row">
        <OnHoldIssue
          vehicleName={vehicleName}
          LC_BUTTON_L2={LC_BUTTON_R2}
          closeDropdown={() => setDropdownBtnsShow(false)}
        />
        <DiscardIssue
          vehicleName={vehicleName}
          LC_BUTTON_L3={LC_BUTTON_L3}
          closeDropdown={() => setDropdownBtnsShow(false)}
        />
      </div>
      <div className="command-row">
        <CreateIssue
          vehicleName={vehicleName}
          closeDropdown={() => setDropdownBtnsShow(false)}
        />
        <CreateRepairOrder
          vehicleName={vehicleName}
          closeDropdown={() => setDropdownBtnsShow(false)}
        />
      </div>
    </div>
  );

  return (
    <>
      <Dropdown
        dropdownRender={() => dropdownContent}
        trigger={['click']}
        placement="topCenter"
        open={dropdownBtnsShow}
        onOpenChange={() => setDropdownBtnsShow(!dropdownBtnsShow)}
      >
        <li className="btn-item vehicle-command">
          <i>工单指令</i>
        </li>
      </Dropdown>
    </>
  );
};

export default React.memo(WordOrderCommand);
